import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { PlatformLocation } from '@angular/common'
import { AuthenticationService } from "@csx/security";


@Component({
  selector: "back-com",
  template: ""
})
export class BackHandleComponent {

  constructor(router: Router, location: PlatformLocation, private authService: AuthenticationService) {
    if (authService.isAuthenticated) {
      router.navigate(['/authorities'], { queryParams: { status: 'open' } });
    }
  }
}
